'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const ClientPortalIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="ClientPortalIcon">
      <svg width="60" height="60" viewBox="0 0 60 60" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0_4994_6111)">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M30 0C13.4315 0 0 13.4315 0 30C0 46.5686 13.4315 60 30 60C46.5686 60 60 46.5686 60 30C60 13.4315 46.5686 0 30 0Z"
            fill="#D8DCE5"
          />
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M38.362 1.18085C36.1649 0.544456 33.8639 0.152497 31.4904 0.036377C36.6591 8.20483 39.8584 17.5636 40.7873 27.3214H19.2126C20.1414 17.5636 23.3408 8.20483 28.5094 0.0363835C26.136 0.152515 23.835 0.544473 21.6378 1.18088C17.3104 9.21094 14.6403 18.1125 13.8331 27.3214H0.11795C0.0398717 28.2039 0 29.0973 0 30C0 30.9027 0.0398718 31.7961 0.11795 32.6786H13.8331C14.6403 41.8875 17.3104 50.7891 21.6378 58.8193C23.835 59.4557 26.136 59.8474 28.5094 59.9636C23.3407 51.795 20.1414 42.4364 19.2126 32.6786H40.7873C39.8584 42.4364 36.6591 51.795 31.4904 59.9636C33.8639 59.8474 36.1649 59.4557 38.362 58.8193C42.6894 50.7891 45.3596 41.8875 46.1666 32.6786H59.8821C59.9601 31.7961 60 30.9027 60 30C60 29.0973 59.9601 28.2039 59.8821 27.3214H46.1666C45.3596 18.1125 42.6894 9.2109 38.362 1.18085Z"
            fill="#5073C3"
          />
        </g>
        <defs>
          <clipPath id="clip0_4994_6111">
            <rect width="60" height="60" fill="white" />
          </clipPath>
        </defs>
      </svg>
    </SvgIcon>
  )
}

ClientPortalIcon.propTypes = {
  sx: PropTypes.object
}
